import { render, staticRenderFns } from "./ComplaintFollow.vue?vue&type=template&id=2e910b70&scoped=true&"
import script from "./ComplaintFollow.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollow.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintFollow.vue?vue&type=style&index=0&id=2e910b70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e910b70",
  null
  
)

export default component.exports